module.exports = __webpack_public_path__ + "static/media/Push Placeholder Web.98ea7b6a.png";